<template>
  <div class="mt-8">

    <template v-if="employments == null"></template>

    <template v-else-if="employments != null && employments.length == 0">
      <div class="text-gray-700 text-base bg-gray-200 p-6 rounded border border-gray-300 text-center">

        <img src="https://cdn0.iconfinder.com/data/icons/25-essential-ui-pack-1/32/Delete-512.png" 
          class="w-12 inline" />

        <div class="mt-4">
          You have not added any employment details. 
          <a href="#" @click.prevent="showAddEmploymentModal('current')" class="underline">Let's add one now</a>.
        </div>
      </div>
    </template>

    <template v-else>

      <div class="text-2xl mt-6 font-thin">Current Employments</div>

      <template v-for="(employment, index) in employments">
        <template v-if="employment.previous == '0'">
          <div class="mt-8">
            <template v-if="employment.status != null && ['0', '1', '2', '3', '11', '12', '13'].indexOf(employment.status.toString()) > -1">
              <FullPartCasualTemp 
                :employment="employment"
                :index="index"
                :updateValue="updateValue"
                :deleteEmployment="deleteEmployment"
                :getEmploymentDuration="getEmploymentDuration"></FullPartCasualTemp>
            </template>

            <template v-else-if="employment.status != null && ['4'].indexOf(employment.status.toString()) > -1">
              <SelfEmployed 
                :employment="employment"
                :index="index"
                :updateValue="updateValue"
                :deleteEmployment="deleteEmployment"
                :getEmploymentDuration="getEmploymentDuration"></SelfEmployed>
            </template>

            <template v-else>
              <EverythingElse 
                :employment="employment"
                :index="index"
                :updateValue="updateValue"
                :deleteEmployment="deleteEmployment"
                :getEmploymentDuration="getEmploymentDuration"></EverythingElse>
            </template>
          </div>
        </template>
      </template>

      <div class="mt-4">
        <div class="text-base">
          If you have more than one job at present, you can add
          other current employment.
        </div>

        <div class="mt-4">
          <a href="#" 
            @click.prevent="showAddEmploymentModal('current')" 
            class="bg-green-500 inline-block hover:bg-green-600 py-2 px-4 text-white font-semibold uppercase no-underline">
            + Add other current employment
          </a>
        </div>
      </div>


      <template v-if="isCurrentLessThanThreeYears">

        <div class="mt-12 text-2xl font-thin">Previous Employments</div>
        <div class="mt-2 text-base mt-1 mb-4">
          * Required since you have only been at your current work for less than 3 years
        </div>


        <template v-for="(employment, index) in employments">
          <template v-if="employment.previous == '1'">
            <template v-if="employment.status != null && ['0', '1', '2', '3', '11'].indexOf(employment.status.toString()) > -1">
              <div class="mt-6">
                <FullPartCasualTemp 
                  :employment="employment"
                  :index="index"
                  :updateValue="updateValue"
                  :deleteEmployment="deleteEmployment"
                  :isCurrentLessThanThreeYears="isCurrentLessThanThreeYears"
                  :getEmploymentDuration="getEmploymentDuration"
                  :numemployments="employments.length"
                  :numPreviousEmployments="numPreviousEmployments"></FullPartCasualTemp>
              </div>
            </template>

            <template v-else-if="employment.status != null && ['4'].indexOf(employment.status.toString()) > -1">
              <div class="mt-6">
                <SelfEmployed 
                  :employment="employment"
                  :index="index"
                  :updateValue="updateValue"
                  :deleteEmployment="deleteEmployment"
                  :isCurrentLessThanThreeYears="isCurrentLessThanThreeYears"
                  :getEmploymentDuration="getEmploymentDuration"
                  :numemployments="employments.length"
                  :numPreviousEmployments="numPreviousEmployments"></SelfEmployed>
              </div>
            </template>

            <template v-else>
              <div class="mt-6">
                <EverythingElse 
                  :employment="employment"
                  :index="index"
                  :updateValue="updateValue"
                  :deleteEmployment="deleteEmployment"
                  :isCurrentLessThanThreeYears="isCurrentLessThanThreeYears"
                  :getEmploymentDuration="getEmploymentDuration"
                  :numemployments="employments.length"
                  :numPreviousEmployments="numPreviousEmployments"></EverythingElse>
              </div>
            </template>
          </template>
        </template>

        <div class="mt-4">
          <a href="#" 
            @click.prevent="showAddEmploymentModal('previous')" 
            class="bg-green-500 inline-block hover:bg-green-600 py-2 px-4 text-white font-semibold uppercase no-underline">
            + Add other previous employment
          </a>
        </div>
      </template>
    </template>

    <div class="button-line">
      <ApplicationButton />
    </div>

    <AddEmploymentModal :addEmployment="addEmployment" />
  </div>
</template>

<script>
  import moment               from 'moment'
  import FullPartCasualTemp   from './employment-types/FullPartCasualTemp'
  import SelfEmployed         from './employment-types/SelfEmployed'
  import EverythingElse       from './employment-types/EverythingElse'
  import ApplicationButton    from '@/shared/components/form/ApplicationButton'
  import { EventBus }         from '@/shared/event-bus'
  import AddEmploymentModal   from './AddEmploymentModal'
  
  export default {

    components: {
      FullPartCasualTemp,
      SelfEmployed,
      EverythingElse,
      ApplicationButton,
      AddEmploymentModal
    },

    data() {
      return {
        employments: null,
      }
    },

    created() {
      this.getEmployments()
    },

    watch : {
      '$route' (to, from) {
        this.getEmployments()
      },
    },

    computed: {
      isCurrentLessThanThreeYears() {
        if(this.employments[0].status != null && this.employments[0].date_started_at != null) {
          let now    = moment()
          let then   = moment(this.employments[0].date_started_at, "YYYY-MM-DD")
          let months = now.diff(then, 'months')          
          return months < 36
        }

        return false
      },

      numPreviousEmployments() {
        let num = 0
        for(let i=0; i < this.employments.length; i++) {
          if(this.employments[i].previous == '1') {
            num++
          }
        }
        return num
      }
    },

    methods : {
      showAddEmploymentModal(currentOrPrevious) {
        this.$modal.show('add-employment-modal', {
          currentOrPrevious : currentOrPrevious
        })
      },

      getEmploymentDuration(employment) {
        let text          = ""
        let momentStarted = null
        let momentEnded   = moment()

        if(employment.date_started_at != null && employment.date_started_at.length > 0) {
          momentStarted = moment(employment.date_started_at, "YYYY-MM-DD")
        }

        if(employment.date_ended_at != null && employment.date_ended_at.length > 0) {
          momentEnded = moment(employment.date_ended_at, "YYYY-MM-DD") 
        }

        if(momentStarted != null) {
          let months = momentEnded.diff(momentStarted, 'months')
          let years  = Math.floor(months / 12)

          text += years + (years == 1 ? " year " : " years ")
          
          if(months % 12 > 0) {
            text += (text.length > 0 ? " and " : "") + (months % 12 ) + (months % 12 == 1 ? ' month' : ' months')
          } else {
            text += " and 0 months"
          }
        }

        return text
      },

      // get the employments
      getEmployments() {
        this.showLoader("Loading employments...")
        this.apiGet({
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId,
        }, 'employment/list', (employments) => {
          this.hideLoader()
          this.employments = employments
        })        
      },

      // a method that will receive the value and update
      updateValue(params) {

        if(params.objectType == 'employment') {
          this.updateEmployment(params.index, params.key, params.value)

          if(params.key == 'date_started_at') {
            this.updateNextEploymentDateEnded(params)
          }
        }

        else if(params.objectType == 'address') {
          this.updateAddress({
            id           : this.employments[params.index].address_id,
            unit_number  : this.employments[params.index].unit_number,
            street_number: this.employments[params.index].street_number,
            street_name  : this.employments[params.index].street_name,
            street_type  : this.employments[params.index].street_type,
            state_id     : this.employments[params.index].state_id,
            subrub       : this.employments[params.index].subrub,
            postcode     : this.employments[params.index].postcode,
            country_id   : this.employments[params.index].country_id,
          }, params.key, params.value)
        }
      },

      // go through the employments and update the date ended based on the previous date started
      updateNextEploymentDateEnded(params) {

        if(params.value != null) {
        
          // clone the employments
          let employments = _.cloneDeep(this.employments)

          // first, let's get the curr + next employment
          let curr = employments[params.index]

          // console.log(curr)

          // is there next one?
          if(employments[params.index + 1] != null) {
            let next = employments[params.index + 1]

            // console.log(next)

            // make sure that the next one is the previous
            if(next.date_ended_at == null && next.previous == 1) {
              let value = moment(params.value, 'YYYY-MM-DD').add(-1, 'days').format('YYYY-MM-DD')
              employments[params.index + 1].date_ended_at = value

              // console.log(value)
              // console.log(employments)

              // update this employment separately + explicitly
              this.apiPost({
                clientId    : this.$route.params.clientId,
                employmentId: employments[params.index + 1].id,
                key         : 'date_ended_at',
                value       : value
              }, 'employment/edit', () => {})
            }
          }

          this.employments = employments
        }
      },

      updateEmployment(index, key, value) {
        if(this.employments[index][key] != value) {
          EventBus.$emit('set-autosave', true)
          
          this.employments[index][key] = value
          // console.log(this.employments[index], key, value)

          this.apiPost({
            clientId    : this.$route.params.clientId,
            employmentId: this.employments[index].id,
            key,
            value
          }, 'employment/edit', () => {
            EventBus.$emit('set-autosave', false)
          })
        }
      },

      deleteEmployment(employmentId, index) {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: "Are you sure you want to delete this?",
          buttons:[{
            label          : 'Yes',
            color          : 'red',
            loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
            action         : () => {
              this.apiDelete({
                clientId    : this.$store.state[this.$store.state.view + 'Module'].client.id,
                employmentId: employmentId
              }, 'employment/delete', () => {
                this.$modal.hide('confirm-modal')
                this.employments.splice(index, 1)
                EventBus.$emit('notification-event', {
                  'type'   : 'success',
                  'message': "Employment deleted successfully"
                });
              })
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      },

      addEmployment(type, status) {
        this.showLoader("Adding an employment...")
        this.apiPost({
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId,
          type       : type,
          status     : status
        }, 'employment/create', (employment) => {
          this.hideLoader()
          let employments    = _.cloneDeep(this.employments)
          let lastEmployment = _.last(employments)

          // work out if we need to populate date_ended_at for the
          // employment that was just added, we only need to populate
          // previous employments
          if(employment.previous == 1 && employment.date_ended_at == null && lastEmployment != null) {

            if(lastEmployment.previous == 0) {
              lastEmployment = _.first(employments)
            }

            // if lastEmployment is previous, then we can set the date_ended_at
            if(lastEmployment.date_started_at != null) {
              let value = moment(lastEmployment.date_started_at, 'YYYY-MM-DD').add(-1, 'days').format('YYYY-MM-DD')
              employment.date_ended_at = value
              
              // update this employment separately + explicitly
              this.apiPost({
                clientId    : this.$route.params.clientId,
                employmentId: employment.id,
                key         : 'date_ended_at',
                value       : value
              }, 'employment/edit', () => {
                this.getEmployments()
              })
            }

            else {
              this.getEmployments()
            }
          }

          else {
            this.getEmployments()
          }
        })
      },
    }
  }
</script>